import Ajax from '../js/common/ajax';
export default {
	list(params) {
		return Ajax.get("/store/pageList", params)
	},
	bindNewUser(params = {}) {
		return Ajax.post("/store/bindAccountUser", params)
	},
}